import { render, staticRenderFns } from "./CheckboxTree.vue?vue&type=template&id=5c9e27aa&scoped=true&"
import script from "./CheckboxTree.vue?vue&type=script&lang=js&"
export * from "./CheckboxTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9e27aa",
  null
  
)

export default component.exports